import React from "react";
import {
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
  Mail,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[--primary-wine-dark] text-white pt-16 pb-10 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Column 1: Brand Info */}
        <div className="space-y-4">
          <h2
            className="text-2xl font-bold text-[--accent-gold] cursor-pointer"
            onClick={() => navigate("/")}
          >
            Carneiro Wine
          </h2>
          <p className="text-sm text-gray-300">
            Handcrafted homemade wines rooted in family tradition. Fermented
            with love, crafted with care.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h3 className="text-xl font-semibold text-white mb-4">Quick Links</h3>
          <ul className="space-y-2 text-gray-300 text-sm">
            <li>
              <span
                onClick={() => navigate("/")}
                className="hover:text-[--accent-gold] transition cursor-pointer"
              >
                Home
              </span>
            </li>
            <li>
              <span
                onClick={() => navigate("/products")}
                className="hover:text-[--accent-gold] transition cursor-pointer"
              >
                Products
              </span>
            </li>
            <li>
              <span
                onClick={() => navigate("/about")}
                className="hover:text-[--accent-gold] transition cursor-pointer"
              >
                About Us
              </span>
            </li>
            <li>
              <span
                onClick={() => navigate("/contact")}
                className="hover:text-[--accent-gold] transition cursor-pointer"
              >
                Contact
              </span>
            </li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div>
          <h3 className="text-xl font-semibold text-white mb-4">Contact</h3>
          <ul className="space-y-2 text-gray-300 text-sm">
            <li>
              Email:{" "}
              <a
                href="mailto:ronnie@carneriowine.com"
                className="hover:text-[--accent-gold]"
              >
                ronnie@carneriowine.com
              </a>
            </li>
            <li>
              WhatsApp:{" "}
              <a
                href="https://wa.me/919881055454"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[--accent-gold]"
              >
                +91 98810 55454
              </a>
            </li>
            <li>Location: Mulgaon, Vasai (West), Maharashtra</li>
          </ul>
        </div>

        {/* Column 4: Socials & Payments */}
        <div className="flex flex-col gap-8">
          {/* Follow Us */}
          <div>
            <h3 className="text-xl font-semibold text-white mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/carneirowine/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#1877F2] text-white p-2.5 rounded-full hover:scale-105 transition-transform shadow-md"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/carneirowine/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#E4405F] text-white p-2.5 rounded-full hover:scale-105 transition-transform shadow-md"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://teams.live.com/l/invite/FEA2R-JRHuJV4W6XgI"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#6264A7] text-white p-2.5 rounded-full hover:scale-105 transition-transform shadow-md"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* We Accept / Payments */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 mb-3 uppercase tracking-wider">
              We Accept
            </h3>
            <div className="flex flex-wrap gap-2 items-center">
              {/* UPI */}
              <div className="bg-white px-3 py-1.5 rounded text-xs font-extrabold text-[#666666] tracking-widest flex items-center shadow-sm">
                UPI
              </div>
              {/* RuPay */}
              <div className="bg-white px-2 py-1.5 rounded text-[11px] font-extrabold tracking-wide flex items-center shadow-sm">
                <span className="text-[#0A3A85]">Ru</span>
                <span className="text-[#F58220]">Pay</span>
              </div>
              {/* Visa */}
              <div className="bg-[#1A1F71] text-white px-3 py-1.5 rounded text-xs font-bold italic tracking-wider shadow-sm">
                VISA
              </div>
              {/* Mastercard */}
              <div className="bg-[#141414] px-3 py-1.5 rounded flex items-center shadow-sm">
                <div className="w-3 h-3 bg-[#EB001B] rounded-full opacity-90"></div>
                <div className="w-3 h-3 bg-[#F79E1B] rounded-full -ml-1.5 opacity-90 mix-blend-screen"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-400">
        &copy; {new Date().getFullYear()}, All rights reserved. Powered by{" "}
        <a
          href="https://100billiontech.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-white"
        >
          100billion Tech
        </a>
      </div>
    </footer>
  );
};

export default Footer;